module.exports = __webpack_public_path__ + "img/20210701_172217.bbb16573.jpg";